import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import styles from './PreviewImages.module.css';



const PreviewImages = ({ icon, preview, mdSpan = 8 }) => {
  return (
    <>
      <Col xs={24} md={mdSpan} xxl={mdSpan}>
        <img className={styles.previewImage} alt="icon" src={icon} />
      </Col>
      <Col xs={24} md={mdSpan} xxl={mdSpan}>
        <img className={styles.previewImage} alt="preview" src={preview} />
      </Col>
    </>
  );
};

PreviewImages.propTypes = {
  icon: PropTypes.string.isRequired,
  preview: PropTypes.string.isRequired,
  mdSpan: PropTypes.number,
};

export default PreviewImages;
